/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { gameGetGameSteamSummary } from "../../funcs/gameGetGameSteamSummary.js";
import { GetGameSteamSummaryRequest$zodSchema } from "../../models/getgamesteamsummaryop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: GetGameSteamSummaryRequest$zodSchema.optional(),
};

export const tool$gameGetGameSteamSummary: ToolDefinition<typeof args> = {
  name: "game-get-game-steam-summary",
  description: `查询 Steam 用户

想在你的网站或应用中展示用户的 Steam 个人资料？这个接口就是为你准备的。

## 功能概述
通过一个用户的 Steam 标识（支持多种格式），你可以获取到他公开的个人资料摘要，包括昵称、头像、在线状态、真实姓名（如果公开）和个人资料主页URL等信息。

## 支持的参数格式
接口现在支持以下几种标识符格式：
- **\`steamid\`**: 64位SteamID（如 \`76561197960287930\`）
- **\`id\`**: 自定义URL名称（如 \`gabelogannewell\`）
- **\`id3\`**: Steam ID3格式（如 \`STEAM_0:0:22202\`）
- 完整的个人资料链接
- 好友代码

## 使用须知

> [!IMPORTANT]
> **API Key 安全**
> 此接口需要一个 Steam Web API Key。我们强烈建议由后端统一配置和调用，以避免在客户端泄露。当然，你也可以通过 \`key\` 查询参数临时提供一个Key来覆盖后端配置。

在处理响应时，请注意以下数字代码的含义：
- **\`personastate\` (用户状态)**: 0-离线, 1-在线, 2-忙碌, 3-离开, 4-打盹, 5-想交易, 6-想玩。
- **\`communityvisibilitystate\` (社区可见性)**: 1-私密, 3-公开 (API通常只能查到这两种状态)。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await gameGetGameSteamSummary(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
